import React from 'react'

const CustomBackgroundRightArrow = (props) => {
  return (
    <button
      onClick={() => props.onClick?.()}
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom-arrow right background"
      aria-label="Right Arrow"
    ></button>
  )
}

export default CustomBackgroundRightArrow